export const commons = {
  data() {
    return {
      assetsPathBase: "/images/portal/home"
    };
  }
};
